import { findQuillByNode } from '../../editor/utils/findByNode';

export const selectedClassName = 'ql-selected';

export default function selectNode(target: Element | null, container: Element) {
  const closestQuillContainer = container.closest('.ql-container');
  const nodes = container.querySelectorAll(`.${selectedClassName}`);
  Array.from(nodes)
    .filter(
      (node) =>
        node !== target &&
        node.closest('.ql-container') === closestQuillContainer,
    )
    .forEach((descendant) => {
      if (descendant.classList.length === 1) {
        descendant.removeAttribute('class');
      } else {
        descendant.classList.remove(selectedClassName);
      }
    });
  if (target != null && !target.classList.contains(selectedClassName)) {
    target.classList.add(selectedClassName);
    if (closestQuillContainer) {
      const quill = findQuillByNode(closestQuillContainer);
      if (quill?.isEnabled()) {
        quill.scrollSelectionIntoView();
      }
    }
  }
}
